import { cancelableSecureRequest, secureRequest } from "utils/request";

import { NotificationType } from "types/notification";

export const getNotificationsList = ({skipCount, recordCount, type}: { skipCount: number, recordCount: number, type: NotificationType }) =>
    cancelableSecureRequest(`api/v1/events/ring/list?type=${type}&skipCount=${skipCount}&recordCount=${recordCount}`);

export const getNotificationsCount = () => secureRequest(`api/v1/events/ring/count`, undefined, {handleNoResponse: false});